import * as React from 'react';

function CellTower(props) {
  return (
    <svg width={41} height={62} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M19.364 17.09a11238.74 11238.74 0 0 0-4.629 14.75 1 1 0 0 0 .138.876L31.69 56.529c.661.937 2.122.204 1.767-.886l-7.586-23.331-4.596-15.21c-.285-.942-1.615-.95-1.91-.012Z"
        stroke="#8008f7"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.136 17.09c1.364 4.337 2.987 9.506 4.629 14.75a1 1 0 0 1-.138.876L8.81 56.529c-.661.937-2.122.204-1.767-.886l7.586-23.331 4.596-15.21c.285-.942 1.615-.95 1.91-.012Z"
        stroke="#8008f7"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={20.153} cy={15.034} r={3.831} fill="#8008f7" />
      <path
        d="M27.814 6.415c2.356 2.026 3.83 4.923 3.83 8.14 0 3.217-1.474 6.114-3.83 8.14"
        stroke="#C5CAD5"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.56 1.627c3.53 3.199 5.746 7.806 5.746 12.928 0 5.122-2.215 9.73-5.746 12.928"
        stroke="#8008f7"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.212 22.004a10.26 10.26 0 0 1-3.298-7.549c0-2.982 1.27-5.669 3.298-7.548"
        stroke="#C5CAD5"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.942 27.908A18.155 18.155 0 0 1 1 14.454C1 9.124 3.29 4.33 6.942 1"
        stroke="#8008f7"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default CellTower;
